/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_No_Withdrawal_SuffixInputs */

const en_checkout_no_withdrawal_suffix = /** @type {(inputs: Checkout_No_Withdrawal_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`applies instead.`)
};

/**
* | output |
* | --- |
* | "applies instead." |
*
* @param {Checkout_No_Withdrawal_SuffixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_no_withdrawal_suffix = /** @type {((inputs?: Checkout_No_Withdrawal_SuffixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_No_Withdrawal_SuffixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_no_withdrawal_suffix(inputs)
});